import { render, staticRenderFns } from "./UpdateIdentifierVerifyDialog.vue?vue&type=template&id=06e52a04&scoped=true&"
import script from "./UpdateIdentifierVerifyDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateIdentifierVerifyDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=06e52a04&scoped=true&lang=css&"
import style1 from "./UpdateIdentifierVerifyDialog.vue?vue&type=style&index=1&id=06e52a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e52a04",
  null
  
)

export default component.exports